document.addEventListener("DOMContentLoaded", function () {
  const scrollTriggers = document.querySelectorAll("[data-scroll-to]");
  const scrollTargets = document.querySelectorAll("[data-scroll-target]");
  const headerOffset = 100;

  scrollTriggers.forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      if (window.innerWidth <= 767) {
        e.preventDefault();

        const targetAttr = trigger.getAttribute("data-attr");
        if (!targetAttr) return;

        scrollTargets.forEach(target => {
          const targetValue = target.getAttribute("data-attr");
          if (targetValue === targetAttr) {
            const elementPosition = target.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }
        });
      }
    });
  });
});